import WithRender from "../../templates/ui/networkError.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getNetworkMessage"])
  }
});
